import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 2 * 60 * 1000, // 2 min default
            gcTime: 10 * 60 * 1000,   // 10 min garbage collection
            retry: 1,
            refetchOnWindowFocus: false,
        },
    },
});

// Cache key constants
export const CACHE_KEYS = {
    CATEGORIES: ["categories"],
    CATEGORIES_ACTIVE: ["categories", "active"],
    BRANDS: ["brands"],
    THEME: ["theme"],
    PRODUCTS: "products",
    CATEGORY_BRANDS: "category-brands",
    PARAM_VALUES: "param-values",
    BESTSELLERS: "bestsellers",
    STOCK_SUMMARY: "stock-summary",
    BRAND_CONFIGS: ["brand-configs"],
};

// Stale times by data type
export const STALE_TIMES = {
    STATIC: 5 * 60 * 1000,      // 5 min for categories, brands, theme
    SEMI_STATIC: 60 * 1000,     // 1 min for product lists
    DYNAMIC: 30 * 1000,          // 30 sec for stock, prices
};

// Local storage cache for ultra-static data
const LS_PREFIX = "sg_cache_";
const LS_TTL = 5 * 60 * 1000; // 5 min

export function getLocalCache(key) {
    try {
        const raw = localStorage.getItem(LS_PREFIX + key);
        if (!raw) return null;
        const { data, ts } = JSON.parse(raw);
        if (Date.now() - ts > LS_TTL) {
            localStorage.removeItem(LS_PREFIX + key);
            return null;
        }
        return data;
    } catch {
        return null;
    }
}

export function setLocalCache(key, data) {
    try {
        localStorage.setItem(LS_PREFIX + key, JSON.stringify({ data, ts: Date.now() }));
    } catch {}
}

export function clearAllCache() {
    queryClient.clear();
    Object.keys(localStorage).forEach(k => {
        if (k.startsWith(LS_PREFIX)) localStorage.removeItem(k);
    });
    sessionStorage.clear();
}

/**
 * Invalidate all frontend caches after admin write operations.
 * Clears React Query cache + localStorage cache so fresh data is fetched.
 */
export function invalidateAllStoreCaches() {
    // Clear localStorage caches
    Object.keys(localStorage).forEach(k => {
        if (k.startsWith(LS_PREFIX)) localStorage.removeItem(k);
    });
    // Invalidate all React Query caches (marks as stale, refetches on next access)
    queryClient.invalidateQueries();
}
